import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app
  },
  getters: getters
});
export default store;